const ERROR_CODE = {
  generic: 'Generic',
  alreadyRated: 'AlreadyRated',
  timeLimit: 'TimeLimit',
};

export default ERROR_CODE;
